module.exports = __webpack_public_path__ + "img/shoppingCart.a5f583f3.jpg";